/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Update_Payment_MethodInputs */



/**
* | output |
* | --- |
* | "Update Payment Method" |
*
* @param {Sub_Dashboard_Update_Payment_MethodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_update_payment_method = /** @type {((inputs?: Sub_Dashboard_Update_Payment_MethodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Update_Payment_MethodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlungsmethode aktualisieren")
	return /** @type {LocalizedString} */ ("Update Payment Method")
});